import Vue from 'vue';
import {AppSettings} from "@/shared/AppSettings";
import Rollbar from 'vue-rollbar';

if (AppSettings.isProduction()) {
  Vue.use(Rollbar, {
    accessToken: AppSettings.getRollbarAccessToken(),
    captureUncaught: true,
    captureUnhandledRejections: true,
    enabled: true,
    source_map_enabled: true,
    environment: 'production',
    payload: {
      client: {
        javascript: {
          code_version: '1.0',
          source_map_enabled: true,
          guess_uncaught_frames: true
        }
      }
    }
  });

  Vue.config.errorHandler = (err, vm, info) => {
    Vue.rollbar.error(err);
    console.error(err);
  };
  Vue.config.warnHandler = function (msg, vm, trace) {
    // `trace` is the component hierarchy trace
    Vue.rollbar.warning(msg + trace);
  };
}


